"use client"

import { Phone } from 'lucide-react'

interface FloorPlanCTAProps {
  planName: string
}

export default function FloorPlanCTA({ planName }: FloorPlanCTAProps) {
  const handleGetGuide = () => {
    window.dispatchEvent(new CustomEvent('showQuoteModal'))
  }

  return (
    <section className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl font-bold mb-3">
          Ready to Make {planName} Your Home?
        </h2>
        <p className="text-lg text-gray-300 mb-6">
          Get your free buyer's guide with pricing and specifications
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:9283610298"
            className="bg-[#c88546] text-white px-8 py-3 rounded hover:bg-[#b87436] transition-colors inline-flex items-center justify-center"
          >
            <Phone className="w-5 h-5 mr-2" />
            Call (928) 361-0298
          </a>
          <button
            onClick={handleGetGuide}
            className="bg-white text-gray-900 px-8 py-3 rounded hover:bg-gray-100 transition-colors inline-flex items-center justify-center"
          >
            Get Free Buyer's Guide
          </button>
        </div>
      </div>
    </section>
  )
}